function toUtcTimestamp(date: Date): number {
  return Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
  );
}

/** First non-placeholder class/event title for AR UI (QT-595). */
export function pickArInvoiceEntityTitle(
  eventTitle: string | undefined,
  enrollmentTitle: string | undefined,
): string {
  for (const raw of [eventTitle, enrollmentTitle]) {
    if (typeof raw !== 'string') continue;
    const s = raw.trim();
    if (s.length === 0 || s.toLowerCase() === 'n/a') continue;
    return s;
  }
  return '';
}

/** Matches backend AR aging: dueDate, else createdAt; UTC day boundaries. */
export function isArInvoicePastDue(
  dueDate: string | undefined,
  createdAt: string,
  now = new Date(),
): boolean {
  const raw = dueDate || createdAt;
  if (!raw) return false;
  const effective = new Date(raw);
  if (!Number.isFinite(effective.getTime())) return false;
  return toUtcTimestamp(effective) <= toUtcTimestamp(now);
}
